import { supabase } from './supabase'; // mevcut supabase-js client'ı AUTH için kullanılacak

const API_BASE = process.env.REACT_APP_API_BASE;

async function getAccessToken() {
  const { data } = await supabase.auth.getSession();
  return data?.session?.access_token || null;
}

export async function apiFetch(path, options = {}) {
  const token = await getAccessToken();
  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });

  if (res.status === 401) {
    throw new Error('Unauthorized');
  }
  return res;
}
